export const regExpEmail =
    /^[_a-zA-Z0-9]+([._%+-]*[_a-zA-Z0-9])*@(?:[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*\.[a-z]{2,}|(([0-9]{1,3}\.){3}[0-9]{1,3}|[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*)*\.[a-z]{2,}))$/;

export function isValidMail(value) {
    return regExpEmail.test(value.trim());
}
